module.exports = __webpack_public_path__ + "acd8cc6ea7e97da3ca3c0e5cb4f31caf.svg";


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/credit.svg
// module id = 607
// module chunks = 0